import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center position-relative me-1"
}
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "svg-icon svg-icon-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Upload Data ")
const _hoisted_6 = {
  class: "modal fade",
  ref: "uploadModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal-upload_sekolah"
}
const _hoisted_7 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_8 = { class: "modal-content rounded" }
const _hoisted_9 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Upload Data Sekolah"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-5" }, " Format dokumen Excel (Sesuai Template) ")
], -1)
const _hoisted_13 = { class: "d-flex flex-column mb-8 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Pilih Dokumen")
], -1)
const _hoisted_15 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = ["data-kt-indicator", "disabled"]
const _hoisted_20 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Upload ")
const _hoisted_22 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_23 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_response_upload"
}
const _hoisted_28 = { class: "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" }
const _hoisted_29 = { class: "modal-content rounded" }
const _hoisted_30 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_31 = { class: "svg-icon svg-icon-1" }
const _hoisted_32 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_36 = { class: "col" }
const _hoisted_37 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_38 = { class: "col" }
const _hoisted_39 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_40 = {
  key: 0,
  class: "table-responsive mt-4"
}
const _hoisted_41 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note")
  ])
], -1)
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    (_ctx.items.role != 'IMPLEMENTATOR_LEADER' && _ctx.items.role != 'IMPLEMENTATOR_MEMBER' && _ctx.items.role != 'ADMIN_LEGAL' )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-warning",
              "data-bs-toggle": "modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.callModal()))
            }, [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
              ]),
              _hoisted_5
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.batalUpload()))
            }, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_form, {
              id: "kt_modal-upload_sekolah",
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.targetData,
              ref: "formRef",
              class: "form"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_el_form_item, { prop: "file" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("input", {
                        name: "file",
                        accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        type: "file",
                        id: "file",
                        class: "form-control form-control-lg",
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleFileUpload($event))),
                        key: _ctx.items.fileInputKey
                      }, null, 32))
                    ]),
                    _: 1
                  }),
                  (_ctx.targetData.file == '' )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.items.errorfile), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17))
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-info me-3",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.templateExcel()))
                  }, " Download Template "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger me-3",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batalUpload()))
                  }, " Batal "),
                  _createElementVNode("button", {
                    "data-kt-indicator": _ctx.loading ? 'on' : null,
                    class: "btn btn-lg btn-primary",
                    type: "submit",
                    disabled: _ctx.items.disableButton
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("span", _hoisted_22, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_26))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_19)
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.kembaliSekolah()))
            }, [
              _createElementVNode("span", _hoisted_31, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, [
                  _createElementVNode("span", null, "Total Sekolah = " + _toDisplayString(_ctx.items.total), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, [
                  _createElementVNode("span", null, "Data Sekolah Valid = " + _toDisplayString(_ctx.items.valid), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("label", _hoisted_39, [
                  _createElementVNode("span", null, "Data Sekolah Tidak Valid = " + _toDisplayString(_ctx.items.unValid), 1)
                ])
              ])
            ]),
            (_ctx.items.unValidData.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("table", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.unValidData, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_43, _toDisplayString(item.name), 1),
                          _createElementVNode("td", _hoisted_44, _toDisplayString(item.status), 1),
                          _createElementVNode("td", _hoisted_45, _toDisplayString(item.note), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger me-3",
              "data-bs-dismiss": "modal",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.kembaliSekolah()))
            }, " Kembali ")
          ])
        ])
      ])
    ])
  ], 64))
}